export default __webpack_public_path__ + "static/media/supplier-risk.3c9659a9.png";